import { Vue, Options } from 'vue-class-component';
import Menu from 'primevue/menu';
import MegaMenu from 'primevue/megamenu';
import { mapState } from 'vuex';
import { SET_SIDEBAR_EXPANDED } from '@/core/store/action-types';

@Options({
  name: 'TheSidebar',
  components: {
    Menu,
    MegaMenu,
  },
  computed: {
    ...mapState(['menuItemsContextual', 'isSidebarExpanded']),
  },
})
export default class TheSidebar extends Vue {
  isSidebarExpanded!: boolean;

  toggleSidebarExpand(doShow: boolean) {
    this.$store.dispatch(SET_SIDEBAR_EXPANDED, doShow);
  }
}
